import { Component } from "../lib/component.ts";

class ProductTile extends Component {
  connectedCallback(): void {
    super.connectedCallback();
    this.addEventListener("click", this.#handleClick, { signal: this.signal });
    this.addEventListener("auxclick", this.#handleAuxClick, {
      signal: this.signal,
    });
  }

  #handleClick = (event: MouseEvent): void => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest("a, button")) return;
    if (window.getSelection()?.isCollapsed === false) return;

    const link = this.querySelector("a");
    if (!link) return;

    if (event.metaKey || event.ctrlKey) {
      window.open(link.href, "_blank");
    } else {
      link.click();
    }
  };

  #handleAuxClick = (event: MouseEvent): void => {
    if (event.button !== 1) return;
    if (!(event.target instanceof Element)) return;
    if (event.target.closest("a, button")) return;

    const link = this.querySelector("a");
    if (!link) return;

    window.open(link.href, "_blank");
  };
}

if (!customElements.get("product-tile")) {
  customElements.define("product-tile", ProductTile);
}
